import React 			from 'react';
import ReactDOM 		from 'react-dom';

import BLComponent		from '../core/_BLComponent.jsx';
import PortalHeader	from '../_portal/_PortalHeader.jsx';

import {NotificationBar} from '../common/_Utilities.jsx';

export default class Header extends BLComponent
{
	constructor( props ) 
	{
		super( props );
	}

	render() 
	{
		return <PortalHeader ref="header"/>;
	}

	renderFloatNotification() {
		if(blapp.util.getUrlVars().floatNotification) {
			const content = blapp.util.getUrlVars().floatNotification;
			const type 		= blapp.util.getUrlVars().floatNotificationType;

			let url = window.location.href;
					url = blapp.util.removeParamFromUrl('floatNotification', url);
					url = blapp.util.removeParamFromUrl('floatNotificationType', url);

			window.history.pushState('', '', url)

			return NotificationBar(content, type);
		}

		return;
	}

	showLogin = ( callback, mod ) =>
	{
		bl.login.showLoginModal(callback, mod);
	}

	hideLogin = () =>
	{
		bl.login.closeSignupModal();
	}

	toggleMenu = ( link )  =>
	{
		this.refs[ "header" ].toggleMenu( link );
	}

	onSessionUpdate = () => 
	{
		this.refs[ "header" ].onSessionUpdate();
	};
};

document.addEventListener( "DOMContentLoaded", 
	function() {
		var	header	=	ReactDOM.render(
							<Header/>
						,	document.getElementById( 'bl-header' )
						);
		blapp.refs.register( "header", header );
		blapp.session.onSessionUpdate( () => header.onSessionUpdate() );
	}
);
 
//<Header openMenu={this.props.openMenu} isHome={this.props.isHome} carts={this.props.carts} settings={this.props.settings} trendingSearches={this.props.trendingSearches} func={this.props.func}/>



